import Button from "@/common/components/Button";
import DeclineModal from "@/features/establishmentLeadsFunnel/components/DeclineModal";
import { UseMutateFunction } from "@tanstack/react-query";
import { twMerge } from "tailwind-merge";

interface ReviewButtonsProps {
  name?: string
  reviewState?: string;
  onApprove?: UseMutateFunction<void, Error, { description?: string; } | undefined, unknown>;
  onDecline?: UseMutateFunction<void, Error, { description?: string; } | undefined, unknown>;
  isPending?: boolean;
  hideDeclineButton?: boolean;
  hideApproveButton?: boolean;
}

export const ReviewButtons = ({
  name,
  reviewState,
  onApprove,
  onDecline,
  isPending,
  hideDeclineButton,
  hideApproveButton,
}: ReviewButtonsProps) => {
  return (
    <div className="flex gap-2">
      {(!hideDeclineButton && !!onDecline) && (
        <>
          {reviewState === 'disapproved' ? (
            <Button type="button" className="w-[164px] cursor-default" variant="error" disabled>Declinado</Button>
          ) : (
            <DeclineModal submit={onDecline} />
          )}
        </>
      )}

      {(!hideApproveButton && !!onApprove) && (
        <Button
          name={name ? `${name}_approved` : 'approved'}
          type="button"
          className={twMerge("w-[164px]", reviewState === 'approved' && "bg-success-disabled")}
          onClick={(event) => {
            event.preventDefault();
            onApprove({});
          }
          }
          disabled={reviewState === 'approved' || !!isPending}
        >
          {reviewState === 'approved' ? "Aprovado" : "Aprovar"}
        </Button>
      )}
    </div>
  );
};
